/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Created_LabelInputs */

const en_knp_guide_created_label = /** @type {(inputs: Knp_Guide_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Created:`)
};

const fr_knp_guide_created_label = /** @type {(inputs: Knp_Guide_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créé :`)
};

const de_knp_guide_created_label = /** @type {(inputs: Knp_Guide_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellt:`)
};

const it_knp_guide_created_label = /** @type {(inputs: Knp_Guide_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creato:`)
};

const ru_knp_guide_created_label = /** @type {(inputs: Knp_Guide_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Созданный:`)
};

const es_knp_guide_created_label = /** @type {(inputs: Knp_Guide_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creado:`)
};

const zh_cn2_knp_guide_created_label = /** @type {(inputs: Knp_Guide_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建时间：`)
};

const ja_knp_guide_created_label = /** @type {(inputs: Knp_Guide_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`作成日:`)
};

const hi_knp_guide_created_label = /** @type {(inputs: Knp_Guide_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बनाया था:`)
};

const pt_pt2_knp_guide_created_label = /** @type {(inputs: Knp_Guide_Created_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criado:`)
};

/**
* | output |
* | --- |
* | "Created:" |
*
* @param {Knp_Guide_Created_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_created_label = /** @type {((inputs?: Knp_Guide_Created_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Created_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_created_label(inputs)
	if (locale === "de") return de_knp_guide_created_label(inputs)
	if (locale === "it") return it_knp_guide_created_label(inputs)
	if (locale === "ru") return ru_knp_guide_created_label(inputs)
	if (locale === "es") return es_knp_guide_created_label(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_created_label(inputs)
	if (locale === "ja") return ja_knp_guide_created_label(inputs)
	if (locale === "hi") return hi_knp_guide_created_label(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_created_label(inputs)
	return en_knp_guide_created_label(inputs)
});